﻿const diagramsLocaleColorDict = {
    ru: {
        white: 'Белый',
        blue: 'Голубой',
        beige: 'Бежевый',
        lightGreen: 'Салатовый',
        red: 'Красный',
        purple: 'Фиолетовый',
        apricot: 'Абрикосовый',
        orange: 'Оранжевый',
        yellow: 'Жёлтый'
    },
    en: {
        white: 'White',
        blue: 'Blue',
        beige: 'Beige',
        lightGreen: 'Light Green',
        red: 'Red',
        purple: 'Purple',
        apricot: 'Apricot',
        orange: 'Orange',
        yellow: 'Yellow'
    },
    th: {
        white: 'ขาว',
        blue: 'ฟ้า',
        beige: 'เบจ',
        lightGreen: 'เขียวอ่อน',
        red: 'แดง',
        purple: 'ม่วง',
        apricot: 'แอปริคอต',
        orange: 'ส้ม',
        yellow: 'เหลือง'
    },
    tr: {
        white: 'Beyaz',
        blue: 'Mavi',
        beige: 'Bej',
        lightGreen: 'Açık yeşil',
        red: 'Kırmızı',
        purple: 'Mor',
        apricot: 'Kayısı',
        orange: 'Turuncu',
        yellow: 'Sarı'
    }
};

const diagramsValidationMessages = {
    ru: {
        diagramLoadError: 'Не удалось загрузить блок-схему',
        diagramParseError: 'Ошибка парсинга BPMN-диаграммы',
        diagramSaveError: 'Не удалось сохранить диаграмму',
        diagramCreateError: 'Не удалось создать новую диаграмму',
        instanceNotInitialized: 'BPMN instance not initialized',
        httpError: 'при загрузке диаграммы',
        errorTitle: 'Ошибка'
    },
    en: {
        diagramLoadError: 'Failed to load diagram',
        diagramParseError: 'BPMN diagram parsing error',
        diagramSaveError: 'Failed to save diagram',
        diagramCreateError: 'Failed to create new diagram',
        instanceNotInitialized: 'BPMN instance not initialized',
        httpError: 'when loading diagram',
        errorTitle: 'Error'
    },
    th: {
        diagramLoadError: 'ไม่สามารถโหลดผังงานได้',
        diagramParseError: 'เกิดข้อผิดพลาดในการแยกวิเคราะห์ BPMN',
        diagramSaveError: 'ไม่สามารถบันทึกผังงานได้',
        diagramCreateError: 'ไม่สามารถสร้างผังงานใหม่ได้',
        instanceNotInitialized: 'BPMN instance not initialized',
        httpError: 'ขณะโหลดผังงาน',
        errorTitle: 'ข้อผิดพลาด'
    },
    tr: {
        diagramLoadError: 'Diyagram yüklenemedi',
        diagramParseError: 'BPMN diyagramı ayrıştırma hatası',
        diagramSaveError: 'Diyagram kaydedilemedi',
        diagramCreateError: 'Yeni diyagram oluşturulamadı',
        instanceNotInitialized: 'BPMN instance not initialized',
        httpError: 'diyagram yüklenirken',
        errorTitle: 'Hata'
    }
};

export const diagramsLocaleDict = {
    ru: {
        ...diagramsLocaleColorDict.ru,
        ...diagramsValidationMessages.ru
    },
    en: {
        ...diagramsLocaleColorDict.en,
        ...diagramsValidationMessages.en
    },
    th: {
        ...diagramsLocaleColorDict.th,
        ...diagramsValidationMessages.th
    },
    tr: {
        ...diagramsLocaleColorDict.tr,
        ...diagramsValidationMessages.tr
    }
};
